/* ============================================================
   LOW KEY AUTOMOTIVE - YEAR/MAKE/MODEL/ENGINE DATABASE
   Diesel + gas (domestic trucks/SUVs) selector data for YMM fitment.
   Gas vehicles use one engine label (E.GAS). Gas fitment is matched on
   Turn 14 year/make/model data in ymm-filter.js, not on engine.
   ============================================================ */

window.YMMData = (function() {

  var CURRENT_YEAR = new Date().getFullYear();
  var PRESENT = Math.max(CURRENT_YEAR, 2026);

  // Engine labels shown in the selector.
  var E = {
    // Gas (any gas engine; fitment is matched on year/make/model)
    GAS:  'Gas Engine',

    // Duramax
    LB7:  '6.6L Duramax LB7 (2001-2004)',
    LLY:  '6.6L Duramax LLY (2004.5-2005)',
    LBZ:  '6.6L Duramax LBZ (2006-2007)',
    LMM:  '6.6L Duramax LMM (2007.5-2010)',
    LML:  '6.6L Duramax LML (2011-2016)',
    L5P:  '6.6L Duramax L5P (2017+)',
    D28:  '2.8L Duramax Diesel (Colorado/Canyon)',
    D30:  '3.0L Duramax Diesel (LM2/LZ0)',

    // Cummins
    C12V: '5.9L Cummins 12-Valve (1989-1998)',
    C24V: '5.9L Cummins 24-Valve (1998.5-2002)',
    C03:  '5.9L Cummins Common Rail (2003-2007)',
    C67:  '6.7L Cummins (2007.5-2018)',
    C67N: '6.7L Cummins (2019+)',

    // Power Stroke
    P73:  '7.3L Power Stroke (1994-2003)',
    P60:  '6.0L Power Stroke (2003-2007)',
    P64:  '6.4L Power Stroke (2008-2010)',
    P67:  '6.7L Power Stroke (2011-2019)',
    P67N: '6.7L Power Stroke (2020+)',
    P30:  '3.0L Power Stroke Diesel (F-150)',

    // EcoDiesel
    ED:   '3.0L EcoDiesel (Ram 1500)'
  };

  // Format: make -> model -> [ [yearStart, yearEnd, [engine_keys...]], ... ]
  var fitment = {
    chevrolet: {
      'Silverado 1500': [
        [2020, 2022, ['D30']],
        [2023, PRESENT, ['D30']]
      ],
      'Silverado 2500HD': [
        [2001, 2004, ['LB7']],
        [2004, 2005, ['LLY']],
        [2006, 2007, ['LBZ']],
        [2007, 2010, ['LMM']],
        [2011, 2016, ['LML']],
        [2017, PRESENT, ['L5P']]
      ],
      'Silverado 3500HD': [
        [2001, 2004, ['LB7']],
        [2004, 2005, ['LLY']],
        [2006, 2007, ['LBZ']],
        [2007, 2010, ['LMM']],
        [2011, 2016, ['LML']],
        [2017, PRESENT, ['L5P']]
      ],
      'Colorado': [
        [2016, 2022, ['D28']]
      ],
      'Suburban': [
        [2021, PRESENT, ['D30']]
      ],
      'Tahoe': [
        [2021, PRESENT, ['D30']]
      ],
      'Express': [
        [2017, 2022, ['D28']]
      ]
    },

    gmc: {
      'Sierra 1500': [
        [2020, 2022, ['D30']],
        [2023, PRESENT, ['D30']]
      ],
      'Sierra 2500HD': [
        [2001, 2004, ['LB7']],
        [2004, 2005, ['LLY']],
        [2006, 2007, ['LBZ']],
        [2007, 2010, ['LMM']],
        [2011, 2016, ['LML']],
        [2017, PRESENT, ['L5P']]
      ],
      'Sierra 3500HD': [
        [2001, 2004, ['LB7']],
        [2004, 2005, ['LLY']],
        [2006, 2007, ['LBZ']],
        [2007, 2010, ['LMM']],
        [2011, 2016, ['LML']],
        [2017, PRESENT, ['L5P']]
      ],
      'Canyon': [
        [2016, 2022, ['D28']]
      ],
      'Yukon': [
        [2021, PRESENT, ['D30']]
      ],
      'Yukon XL': [
        [2021, PRESENT, ['D30']]
      ],
      'Savana': [
        [2017, 2022, ['D28']]
      ]
    },

    dodge: {
      'Ram 1500': [
        [2014, 2019, ['ED']]
      ],
      'Ram 2500': [
        [1989, 1998, ['C12V']],
        [1998, 2002, ['C24V']],
        [2003, 2007, ['C03']],
        [2007, 2018, ['C67']],
        [2019, PRESENT, ['C67N']]
      ],
      'Ram 3500': [
        [1989, 1998, ['C12V']],
        [1998, 2002, ['C24V']],
        [2003, 2007, ['C03']],
        [2007, 2018, ['C67']],
        [2019, PRESENT, ['C67N']]
      ],
      'Ram 4500': [
        [2008, 2018, ['C67']],
        [2019, PRESENT, ['C67N']]
      ],
      'Ram 5500': [
        [2008, 2018, ['C67']],
        [2019, PRESENT, ['C67N']]
      ]
    },

    ram: {
      '1500': [
        [2014, 2019, ['ED']],
        [2020, 2023, ['ED']]
      ],
      '2500': [
        [2010, 2018, ['C67']],
        [2019, PRESENT, ['C67N']]
      ],
      '3500': [
        [2010, 2018, ['C67']],
        [2019, PRESENT, ['C67N']]
      ],
      '4500': [
        [2010, 2018, ['C67']],
        [2019, PRESENT, ['C67N']]
      ],
      '5500': [
        [2010, 2018, ['C67']],
        [2019, PRESENT, ['C67N']]
      ]
    },

    ford: {
      'F-150': [
        [2018, 2021, ['P30']]
      ],
      'F-250 Super Duty': [
        [1994, 2003, ['P73']],
        [2003, 2007, ['P60']],
        [2008, 2010, ['P64']],
        [2011, 2019, ['P67']],
        [2020, PRESENT, ['P67N']]
      ],
      'F-350 Super Duty': [
        [1994, 2003, ['P73']],
        [2003, 2007, ['P60']],
        [2008, 2010, ['P64']],
        [2011, 2019, ['P67']],
        [2020, PRESENT, ['P67N']]
      ],
      'F-450 Super Duty': [
        [1999, 2003, ['P73']],
        [2003, 2007, ['P60']],
        [2008, 2010, ['P64']],
        [2011, 2019, ['P67']],
        [2020, PRESENT, ['P67N']]
      ],
      'F-550 Super Duty': [
        [1999, 2003, ['P73']],
        [2003, 2007, ['P60']],
        [2008, 2010, ['P64']],
        [2011, 2019, ['P67']],
        [2020, PRESENT, ['P67N']]
      ],
      'Excursion': [
        [2000, 2003, ['P73']],
        [2003, 2005, ['P60']]
      ]
    }
  };

  // ── GAS TRUCKS & SUVs (domestic) ────────────────────────────
  // Merged into `fitment` below. A model can have diesel and gas ranges.
  var gas = {
    chevrolet: {
      'Silverado 1500': [[1999, PRESENT]],
      'Silverado 2500HD': [[2001, PRESENT]],
      'Silverado 3500HD': [[2001, PRESENT]],
      'Colorado': [[2004, PRESENT]],
      'Tahoe': [[1995, PRESENT]],
      'Suburban': [[1992, PRESENT]],
      'Avalanche': [[2002, 2013]],
      'Blazer': [[1995, 2005]],
      'Trailblazer': [[2002, 2009]]
    },
    gmc: {
      'Sierra 1500': [[1999, PRESENT]],
      'Sierra 2500HD': [[2001, PRESENT]],
      'Sierra 3500HD': [[2001, PRESENT]],
      'Canyon': [[2004, PRESENT]],
      'Yukon': [[1992, PRESENT]],
      'Yukon XL': [[2000, PRESENT]],
      'Envoy': [[1998, 2009]]
    },
    ford: {
      'F-150': [[1997, PRESENT]],
      'F-250 Super Duty': [[1999, PRESENT]],
      'F-350 Super Duty': [[1999, PRESENT]],
      'Ranger': [[1993, 2011], [2019, PRESENT]],
      'Bronco': [[1992, 1996], [2021, PRESENT]],
      'Bronco Sport': [[2021, PRESENT]],
      'Expedition': [[1997, PRESENT]],
      'Explorer': [[1995, PRESENT]],
      'Excursion': [[2000, 2005]],
      'Maverick': [[2022, PRESENT]]
    },
    dodge: {
      'Ram 1500': [[1994, 2010]],
      'Ram 2500': [[1994, 2010]],
      'Ram 3500': [[1994, 2010]],
      'Dakota': [[1997, 2011]],
      'Durango': [[1998, PRESENT]]
    },
    ram: {
      '1500': [[2011, PRESENT]],
      '1500 Classic': [[2019, 2024]],
      '2500': [[2011, PRESENT]],
      '3500': [[2011, PRESENT]]
    },
    jeep: {
      'Wrangler': [[1987, PRESENT]],
      'Gladiator': [[2020, PRESENT]],
      'Cherokee': [[1984, 2001], [2014, 2023]],
      'Grand Cherokee': [[1993, PRESENT]],
      'Grand Cherokee L': [[2021, PRESENT]],
      'Liberty': [[2002, 2012]],
      'Commander': [[2006, 2010]],
      'Comanche': [[1986, 1992]],
      'Wagoneer': [[2022, PRESENT]],
      'Grand Wagoneer': [[2022, PRESENT]],
      'Renegade': [[2015, 2023]],
      'Compass': [[2007, PRESENT]]
    }
  };

  Object.keys(gas).forEach(function(makeKey) {
    fitment[makeKey] = fitment[makeKey] || {};
    Object.keys(gas[makeKey]).forEach(function(model) {
      var list = fitment[makeKey][model] = fitment[makeKey][model] || [];
      gas[makeKey][model].forEach(function(r) { list.push([r[0], r[1], ['GAS']]); });
    });
  });

  function hasDieselRange(ranges) {
    return (ranges || []).some(function(range) {
      return (range[2] || []).some(function(key) { return !!E[key]; });
    });
  }

  function displayMake(key) {
    if (key === 'gmc') return 'GMC';
    if (key === 'ram') return 'RAM';
    return key.charAt(0).toUpperCase() + key.slice(1);
  }

  function getMakes() {
    return Object.keys(fitment)
      .filter(function(makeKey) {
        var models = fitment[makeKey] || {};
        return Object.keys(models).some(function(model) {
          return hasDieselRange(models[model]);
        });
      })
      .map(displayMake);
  }

  function getModels(make) {
    var key = String(make || '').toLowerCase();
    var entry = fitment[key];
    if (!entry) return [];
    return Object.keys(entry).filter(function(model) {
      return hasDieselRange(entry[model]);
    });
  }

  function getEngines(make, model, year) {
    var mkey = String(make || '').toLowerCase();
    var yr = parseInt(year, 10);

    function lookupEngines(key) {
      var entry = fitment[key];
      if (!entry) return null;
      var ranges = entry[model];
      if (!ranges) return null;

      var out = [];
      for (var i = 0; i < ranges.length; i++) {
        var r = ranges[i];
        if (!isNaN(yr) && yr >= r[0] && yr <= r[1]) {
          r[2].forEach(function(k) {
            if (E[k] && out.indexOf(E[k]) === -1) out.push(E[k]);
          });
        }
      }
      // Diesel engines first, gas last
      out.sort(function(a, b) { return (a === E.GAS ? 1 : 0) - (b === E.GAS ? 1 : 0); });
      return out.length ? out : null;
    }

    var result = lookupEngines(mkey);
    if (result && result.length) return result;

    if (mkey === 'dodge') {
      result = lookupEngines('ram');
      if (result && result.length) return result;
    }
    if (mkey === 'ram') {
      result = lookupEngines('dodge');
      if (result && result.length) return result;
    }

    return [];
  }

  function getValidYears(make, model) {
    var mkey = String(make || '').toLowerCase();
    var entry = fitment[mkey];
    if (!entry) return [];
    var ranges = entry[model];
    if (!ranges) return [];

    var years = [];
    ranges.forEach(function(r) {
      var engineKeys = (r[2] || []).filter(function(k) { return !!E[k]; });
      if (!engineKeys.length) return;
      for (var y = r[0]; y <= r[1]; y++) {
        if (years.indexOf(y) === -1) years.push(y);
      }
    });

    return years.sort(function(a, b) { return b - a; });
  }

  return {
    getMakes: getMakes,
    getModels: getModels,
    getEngines: getEngines,
    getValidYears: getValidYears,
    engineDefs: E
  };

})();

